import $ from 'jquery';
import './slick';

// document.addEventListener('DOMContentLoaded', function () {
$(document).ready(function () {
  Sceon.ClassifiedAd = {};
  Sceon.ClassifiedAd.PagingUrl = 'paging';

  $('.classified-escort-gallery')
    ?.slick({
      infinite: true,
      speed: 200,
      centerMode: true,
      variableWidth: true,
      lazyLoaded: true,
      slidesPerRow: 3,
      slidesToScroll: 1,
      prevArrow:
        '<i class="sc-and6 sc-and6-chevron-left text-bold text-white prev-arrow fs-18"></i>',
      nextArrow:
        '<i class="sc-and6 sc-and6-chevron-right text-bold text-white next-arrow fs-18"></i>',
    })
    .each((index, elm) => {
      let overlay = new Sceon.Overlay($(elm), {
        loader: '/imgr/loader-tiny.gif',
        offset: { bottom: 0, top: 0 },
      });

      overlay.enable();

      setTimeout(() => {
        $(elm).on('setPosition', () => {
          setTimeout(() => {
            $('.classified-escort-gallery .slick-slide').css({
              opacity: 1,
            });

            overlay.disable();
          }, 10);
        });
      });
    });

  Sceon.ClassifiedAd.parseHash = function () {
    let hash = location.hash.substring(1);
    let filter = {};
    if (!hash.length) {
      return {};
    }
    let params = hash.split(';');
    for (let i in params) {
      let name = params[i].split('=')[0];
      let val = params[i].split('=')[1];
      if (name && val) {
        filter[name] = val;
      }
    }
    return filter;
  };

  Sceon.ClassifiedAd.initPaging = function () {
    let filter = Sceon.ClassifiedAd.parseHash();
    filter.pid = $('#pid').val();

    delete filter.per_page;
    delete filter.page;
    if (filter.geo_node_id) {
      filter.geo_node_id = parseInt(filter.geo_node_id);
    }

    if ($('#next-prev').length) {
      $.ajax({
        method: 'GET',
        url: Sceon.ClassifiedAd.PagingUrl,
        data: {
          filter,
        },
        success: function (resp) {
          if (resp.next_id) {
            $('#btn-next')
              .removeClass('hidden')
              .attr('href', `/classified-ads/ad?id=${resp.next_id}`);
          } else {
            $('#btn-next').addClass('hidden').attr('href', '');
          }
          if (resp.previous_id) {
            $('#btn-previous')
              .removeClass('hidden')
              .attr('href', `/classified-ads/ad?id=${resp.previous_id}`);
          } else {
            $('#btn-previous').addClass('hidden').attr('href', '');
          }

          if (resp.next_id || resp.previous_id) {
            $('#next-prev').removeClass('hidden');
          }
        },
        error: function (err) {
          console.error(err);
        },
      });
    }
  };

  function profilePageViewGA(name) {
    event.preventDefault();

    let href = $(this).attr('href');
    let hash = document.location.hash.substring(1);

    if (!href || href === '') {
      return;
    }

    new Promise((resolve) => {
      ga('send', 'event', 'profilepage', name, {
        hitCallback: resolve,
      });

      setTimeout(resolve, 1000);
    }).then(() => {
      location.href = `${href}#${hash}`;
    });
  }

  $('#btn-next').click(function () {
    profilePageViewGA.call(this, 'nextbtn_tap');
  });
  $('#btn-previous').click(function () {
    profilePageViewGA.call(this, 'backbtn_tap');
  });
  Sceon.ClassifiedAd.initPaging();
});
